export default{
    GUEST:'guest',
    RESELLER:'paid_reseller'
}